export const IMF_FEATURE_CACHE: LsCacheConfig = {
  type: 'imgf',
  maxCacheSize: 10,
}

export interface SearchFieldBaseProps {
  field: CustomSearchField
  ss: SearchStore<any>
}

export const useSearchFieldBase = (props: SearchFieldBaseProps) => {
  const { ls, lst, nums } = useI18n()

  const facet = computed(() => {
    if (props.ss.state.result && props.ss.state.result.facets) {
      return props.ss.state.result.facets
        .filter(f => f.key === props.field.key)
        .pop()
    }
    if (props.ss.state.fullFacets) {
      return props.ss.state.fullFacets
        .filter(f => f.key === props.field.key)
        .pop()
    }
    return null
  })

  function facetNum(n: number) {
    if (n === 0) return '-'
    else return nums(n)
  }

  const placeholder = computed(() => {
    if (!isEmpty(props.field.placeHolder)) return ls(props.field.placeHolder)
    return ls(props.field.name)
  })

  function excludeDisplay(value: string, exclude: boolean, count: number) {
    if (exclude) value = lst({ ja: '{}を除外', en: 'Exclude {}' }, value)
    return value
  }
  return { facet, facetNum, placeholder, excludeDisplay }
}
